import { render } from "./SMSProfileModal.vue?vue&type=template&id=3a9450b6&scoped=true&ts=true"
import script from "./SMSProfileModal.vue?vue&type=script&lang=ts"
export * from "./SMSProfileModal.vue?vue&type=script&lang=ts"

import "./SMSProfileModal.vue?vue&type=style&index=0&id=3a9450b6&scoped=true&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9450b6"]])

export default __exports__